import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface SearchItem {
  id: number;
  name: string;
  link: string;
}

export interface SearchData {
  products: SearchItem[];
  services: SearchItem[];
  projects: SearchItem[];
  catalogs: SearchItem[];
  licences: SearchItem[];
  reviews: SearchItem[];
  teams: SearchItem[];
  menus: SearchItem[];
  suppliers: SearchItem[];
  posts: SearchItem[];
  pages: SearchItem[];
}

export class SearchRepository extends BaseRepository<
  SearchData,
  undefined,
  undefined,
  SearchData
> {
  collection = "search";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  public getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<SearchData>> {
    return super.getMany(queryParams);
  }
}
